<template>
  <div class="copyright">
    Copyright© Odakyu Electric Railway Co., Ltd. All Rights Reserved
  </div>
</template>

<script>
export default {
  name: "Copyright",
};
</script>

<style lang="scss" scoped>
.copyright {
  font-weight: 400;
  font-size: 2.67vw;
  line-height: 3.2vw;
  color: #bdbdbd;
  text-align: center;
}
</style>
